import axios from 'axios';
import router from "@/router";
import {useAuthStore} from "@/store/auth.module";
import { parseUserFromStorage } from '@/utils/userStorage';

const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
// Axios 인스턴스 생성
const apiClient = axios.create({
    baseURL: `${VUE_APP_API_BASE_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 요청 인터셉터 설정
apiClient.interceptors.request.use(config => {
    const user = parseUserFromStorage();
    if (user && user.accessToken) {
        config.headers['Authorization'] = 'Bearer ' + user.accessToken;
    }
    return config;
}, error => {
    validateSession(error);
    return Promise.reject(error);
});

// 응답 인터셉터 설정
apiClient.interceptors.response.use(config => {
    return config;
}, error => {
    validateSession(error);
    return Promise.reject(error);
});


const validateSession = (error) => {
    const response = error.response;
    if (!response) {
        // 서버로부터 응답이 없을 때
        alert("서버로부터 응답이 없습니다.");
        return;
    }

    const status = response.status;
    const data = response.data;
    const authStore = useAuthStore();
    console.log("response",status, data);

    if (status === 401) {
        alert(data.message);
        authStore.logout();
        router.push("/").then(() => location.reload());
    } else if (status === 403) {
        alert(data.message);
        router.push("/").then(() => location.reload());
    } else if (status === 502 || status === 503 || status === 504 ) {
        alert(data.message);
    } else if (data) {
        // 검증 실패(400)는 data.message 가 "요청 값이 잘못되었습니다." 라는 총론뿐이고,
        // 어느 항목이 왜 걸렸는지는 data.data 의 필드 오류 목록에 있다 (mimio#45).
        // 그것까지 보여주지 않으면 사용자는 무엇을 고쳐야 할지 모른 채 저장만 실패한다.
        const fieldErrors = Array.isArray(data.data)
            ? data.data.map(e => e && e.message).filter(Boolean)
            : [];
        if (fieldErrors.length) {
            alert(fieldErrors.join("\n"));
        } else if (data.message) {
            alert(data.message);
        } else {
            alert(data);
        }
    } else {
        alert("알 수 없는 오류가 발생했습니다.");
    }
};
export { apiClient };
